import {
  CheckoutResponse,
  StopAutoRenewalCode,
  UpdateAutoRenewalRequest,
} from '@common/util-models';

const AUTO_RENEWAL_CONTACT_US_CATEGORY = 'CANCELLATIONS';

export function getCheckedOutPlanNumbers(
  checkoutResponse: CheckoutResponse | undefined
): string[] {
  return (checkoutResponse?.completedItems ?? [])
    .map((completedItem) => completedItem?.confirmation?.planNumber)
    .filter((planNumber): planNumber is string => !!planNumber);
}

export function formatUpdateAutoRenewalRequest(
  planNumber: string,
  action: StopAutoRenewalCode,
  client?: string
): UpdateAutoRenewalRequest {
  return {
    data: {
      context: {
        contactUsCategory: AUTO_RENEWAL_CONTACT_US_CATEGORY,
        planNumber,
        action,
        ...(client ? { client } : {}),
      },
    },
  };
}
